/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import PopupRadio from "vux/src/components/popup-radio/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import ChinaAddressV4Data from "vux/src/datas/china_address_v4.json"; // this line is trasformed by vux-loader
import XAddress from "vux/src/components/x-address/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import ImgUpload from '@/components/ImgUpload';
import CustomFormList from '@/components/CustomFormList';
import SmyMapAddress from '@/components/CustomFormList/SmyMapAddress';
import { apieventbashinfo, apieventsave, apisystemsettingByCode, apiUpdateName, apicorporation } from '@/api';
import { titleRuleSystemFieldList, priorityList } from '@/constant';
export default {
  name: 'AppointmentEvent',
  components: {
    CustomFormList: CustomFormList,
    XInput: XInput,
    XButton: XButton,
    Group: Group,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    PopupRadio: PopupRadio,
    Datetime: Datetime,
    XSwitch: XSwitch,
    XAddress: XAddress,
    Checklist: Checklist,
    ImgUpload: ImgUpload,
    XTextarea: XTextarea,
    SmyMapAddress: SmyMapAddress,
    Cell: Cell,
    CellBox: CellBox
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    id: [String, Number],
    formData: {
      type: Object
    },
    productId: {
      type: String,
      default: ''
    },
    cpId: {
      type: [String, Number],
      default: ''
    },
    shopId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      productMap: {},
      isShowPriority: 0,
      priority: [],
      priorityList: priorityList,
      ChinaAddressV4Data: ChinaAddressV4Data,
      titleRuleSystemFieldList: titleRuleSystemFieldList,
      serviceName: '',
      productList: [],
      changeAddressList: [],
      // 切换地址列表
      isEdit: false,
      btnLoading: false,
      isShowChangeAddress: true,
      // 切换地址弹窗
      titleRule: '',
      // 标题规则
      template: {},
      changeAddressId: '',
      // 系统字段
      systemFields: {
        detail_desc: '',
        custom_name: '',
        custom_phone: '',
        prov_id: '',
        city_id: '',
        district_id: '',
        street_id: '',
        custom_detail_addr: '',
        custom_latitude: '',
        custom_longitude: '',
        map_name: '',
        gps_addr: '',
        address_type: 1
      },
      customFields: [],
      defaultCode: [],
      fieldList: [],
      // checkorderTagshow: false, // 工单标签弹窗
      // checkProductShow: false, // 产品弹窗
      isProductionFromcustomer: 0 // 是否开启客户产品档案
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  watch: {
    changeAddressId: function changeAddressId(val) {
      if (val) {
        var data = this.changeAddressList.find(function (item) {
          return item.id === val;
        });
        if (Object.keys(data).length > 0) {
          this.systemFields.address_type = data.address_type;
          this.systemFields.custom_detail_addr = data.detail_addr;
          this.systemFields.custom_latitude = data.latitude;
          this.systemFields.custom_longitude = data.longitude;
          this.systemFields.prov_id = data.prov_id;
          this.systemFields.city_id = data.city_id;
          this.systemFields.district_id = data.district_id;
          this.systemFields.map_name = data.map_name;
          this.systemFields.gps_addr = data.gps_addr;
          // 修改默认地址
          this.defaultCode = [data.prov_id + '', data.city_id + '', data.district_id + ''];
        }
      }
    },
    // 编辑工单产品回显
    productList: function productList(val) {
      if (val) this.systemFields.productId = val.map(function (item) {
        return item.id;
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_user', '_pageReload'])), {}, {
    // 添加产品回显
    onCheckProduct: function onCheckProduct(list) {
      if (list) {
        var newList = this.productList.slice(0);
        list.forEach(function (item) {
          if (!newList.some(function (prod) {
            return prod.id === item.id;
          })) newList.push(item);
        });
        this.productList = newList;
      }
    },
    // 选择地址
    selectAddress: function selectAddress(data) {
      this.systemFields.address_type = data.type;
      if (data.type === 1) {
        // 地图选址
        this.systemFields.custom_latitude = data.latitude;
        this.systemFields.custom_longitude = data.longitude;
        this.systemFields.map_name = data.address;
        this.systemFields.gps_addr = data.address;
      } else if (data.type === 2) {
        // 级联选择
        this.systemFields.prov_id = data.code[0];
        this.systemFields.city_id = data.code[1];
        this.systemFields.district_id = data.code[2];
        this.systemFields.street_id = data.code[3];
      }
    },
    // 表单验证
    formValidate: function formValidate() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if (_this.template.is_enable_customer) {
          if (!_this.systemFields.custom_phone) {
            resolve({
              success: false,
              msg: i18n.tc("549")
            });
          } else {
            if (!_this.systemFields.custom_phone.match(/[0-9-()（）]{6,15}/)) {
              resolve({
                success: false,
                msg: i18n.tc("550")
              });
            }
          }
          if (!_this.systemFields.custom_name) {
            resolve({
              success: false,
              msg: i18n.tc("551")
            });
          }
        }
        if (_this.template.is_enable_address) {
          if (!_this.systemFields.address_type) {
            resolve({
              success: false,
              msg: i18n.tc("554")
            });
          }
          if (_this.systemFields.address_type === 1 && !_this.systemFields.map_name) {
            resolve({
              success: false,
              msg: i18n.tc("298")
            });
          }
          if (_this.systemFields.address_type === 2 && (!_this.systemFields.prov_id || !_this.systemFields.city_id)) {
            resolve({
              success: false,
              msg: i18n.tc("298")
            });
          }
        }
        resolve({
          success: true
        });
      });
    },
    // 新建工单表单提交
    submit: function submit() {
      var _this2 = this;
      // 系统字段表单验证
      this.formValidate().then(function (res) {
        if (res.success) {
          // 自定义字段表单验证
          _this2.$refs.customFormList.formValidate().then(function (valid2) {
            if (valid2) {
              // 数据过滤
              var data = _objectSpread(_objectSpread({
                service_id: _this2.id
              }, _this2.systemFields), {}, {
                priority: _this2.priority.join(','),
                list: _this2.customFields.map(function (item) {
                  delete item.name;
                  return item;
                }),
                productId: _this2.productId,
                takeSource: '3'
              });
              if (_this2.systemFields.address_type === 1) {
                // map
                data.prov_id = null;
                data.city_id = null;
                data.district_id = null;
                data.street_id = null;
              } else {
                // select
                data.custom_latitude = null;
                data.custom_longitude = null;
              }
              // 详细地址
              if (_this2.template.c_detailaddress_view === 0) {
                data.custom_detail_addr = '';
              }
              // 预约时间关闭情况下 预约时间数据过滤
              if (_this2.template.o_appointment_view === 0) {
                data.custom_apply_time = '';
              }
              _this2.saveRequest(data);
            }
          });
        } else {
          _this2.$vux.toast.text(res.msg);
        }
      });
    },
    onConfirm: function onConfirm(val) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, user;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiUpdateName({
                  name: val
                });
              case 2:
                res = _context.sent;
                if (res.success) {
                  user = _objectSpread(_objectSpread({}, _this3.user), {}, {
                    name: val
                  });
                  _this3._user(user);
                } else {
                  _this3.$vux.toast.text(res.message);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    saveRequest: function saveRequest(data) {
      var _this4 = this;
      this.btnLoading = true;
      apieventsave(data, 'post').then(function (res) {
        _this4.btnLoading = false;
        if (res.success) {
          if (_this4.user.name !== _this4.systemFields.custom_name) {
            _this4.onConfirm(_this4.systemFields.custom_name);
          }
          if (_this4.isEdit) {
            _this4.$vux.toast.text(i18n.tc("484"));
          } else {
            _this4.$vux.toast.text(i18n.tc("555"));
          }
          // reload order page
          _this4._pageReload({
            order: true
          });
          _this4.$router.push({
            name: 'Project'
          });
        } else {
          _this4.$vux.toast.text(res.message);
        }
      }).catch(function (e) {
        return _this4.btnLoading = false;
      });
    },
    loadSet: function loadSet() {
      var _this5 = this;
      apisystemsettingByCode({
        code: 40004
      }).then(function (res) {
        if (res.success) {
          _this5.isShowPriority = +res.data.value;
        }
      });
    }
  }),
  // 初始化默认属性
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var res, name;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return apieventbashinfo({
                service_id: _this6.id
              });
            case 2:
              res = _context2.sent;
              if (res.success) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              _this6.template = res.data || {};
              _this6.systemFields.service_name = res.data.service_name || '';
              name = res.data.name || '';
              _this6.systemFields.custom_name = name.match(/\d{3}\*{4}\d+/) ? '' : name;
              _this6.systemFields.custom_phone = res.data.phone || '';
              _this6.titleRule = res.data.o_ordername_rule || '';
              _this6.fieldList = res.data.list || [];

              // 地址回显
              _this6.systemFields.address_type = res.data.address_type || 1;
              _this6.systemFields.custom_latitude = res.data.latitude || '';
              _this6.systemFields.custom_longitude = res.data.longitude || '';
              _this6.systemFields.map_name = res.data.map_name || '';
              _this6.systemFields.gps_addr = res.data.gps_addr || '';
              _this6.systemFields.custom_detail_addr = res.data.detail_addr || '';
              _this6.systemFields.prov_id = res.data.prov_id || '';
              _this6.systemFields.city_id = res.data.city_id || '';
              _this6.systemFields.district_id = res.data.district_id || '';
              _this6.systemFields.street_id = res.data.street_id || '';
              _this6.defaultCode = [_this6.systemFields.prov_id, _this6.systemFields.city_id, _this6.systemFields.district_id, _this6.systemFields.street_id];
              if (_this6.productId) {
                apicorporation({
                  productId: _this6.productId
                }).then(function (res) {
                  if (res.success) {
                    _this6.productMap = res.data.productMap;
                  }
                });
              }
              _this6.loadSet();
            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};